import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { notificationsSearchSchema } from "@/features/ZeroAdmin/notifications/filters";
import { resolveCurrentSiteId } from "@/hooks/useLastSelectedSite";

export const Route = createFileRoute("/_auth/settings/notifications")({
  validateSearch: zodValidator(notificationsSearchSchema),
  beforeLoad: ({ context, search }) => {
    const siteId = resolveCurrentSiteId(context.auth?.sites ?? []);
    if (!siteId) throw redirect({ to: "/", replace: true });
    throw redirect({
      to: "/settings/$siteId/notifications",
      params: { siteId },
      search,
      replace: true,
    });
  },
});
